import api from "./api";

const PaymentInformationAPI = {
    getByUserPlanSubscriptionId: (id) => api.get(`/payment-information/user-plan-subscription/${id}`),
    getById: (id) => api.get(`/payment-information/details/${id}`),
};

export default PaymentInformationAPI;